import React from "react";

// ----------------importing components------------------
import Banner from "./Banner/Banner";
import WhereToGo from "./Section 2 Where to go/WhereToGo";

const Destinations = () => {
  return (
    <>
      <Banner />
      <WhereToGo />
    </>
  );
};

export default Destinations;
